export default __webpack_public_path__ + "static/media/donationback.a6c36afe.png";